import * as React from 'react'
import { useLocalStorage } from 'react-use'

import { NO_TEAM } from './AuthContext'

import { Metadata } from 'api'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'

export interface MetadataContext {
  metadata: Metadata
  metadataLoading: boolean
  metadataError: boolean
}

export const MetadataContext = React.createContext<MetadataContext>({
  metadata: [],
  metadataLoading: true,
  metadataError: false
})

export const MetadataProvider: React.FC = ({ children }) => {
  const { currentTeamId } = useAuth()
  const [storedMetadata, setStoredMetadata] = useLocalStorage(
    'attack-metadata',
    []
  )

  const {
    data: metadata,
    isLoading: metadataLoading,
    hasError: metadataError
  } = useAgent(`/metadata?teamId=${currentTeamId}`, storedMetadata, {
    shouldCache: true,
    interval: 1000 * 60 * 60, // 1 hour,
    skipRequest: currentTeamId === NO_TEAM
  })

  React.useEffect(() => {
    setStoredMetadata(metadata)
  }, [metadata, setStoredMetadata])

  return (
    <MetadataContext.Provider
      value={{
        metadata,
        metadataLoading,
        metadataError
      }}
    >
      {children}
    </MetadataContext.Provider>
  )
}
